export const MOBILE_NUMBER_VALID = 'auth/MOBILE_NUMBER_VALID';
export const CLEAR_MOBILE_NUMBER = 'auth/CLEAR_MOBILE_NUMBER';
export const RESEND_VERIFICATION_CODE = 'auth/RESEND_VERIFICATION_CODE';
export const RESTART_LOGIN_PROCESS = 'auth/RESTART_LOGIN_PROCESS';
export const SUBMIT_BET_SLIP_NUMBER = 'auth/SUBMIT_BET_SLIP_NUMBER';
export const SUBMIT_VERIFICATION_CODE = 'auth/SUBMIT_VERIFICATION_CODE';
export const SUBMIT_MOBILE_NUMBER = 'auth/SUBMIT_MOBILE_NUMBER';
export const LOGOUT = 'auth/LOGOUT';
export const LOGOUT_CONFIRM = 'auth/LOGOUT_CONFIRM';
export const LOGOUT_REJECT = 'auth/LOGOUT_REJECT';

export const mobileNumberValid = (mobileNumber) => ({
  type: MOBILE_NUMBER_VALID,
  mobileNumber
});

export const clearMobileNumber = () => ({
  type: CLEAR_MOBILE_NUMBER
});

export const submitMobileNumber = ({ mobileNumber }) => ({
  type: SUBMIT_MOBILE_NUMBER,
  mobileNumber
});

export const submitVerificationCode = ({ mobileNumber, verificationCode }) => ({
  type: SUBMIT_VERIFICATION_CODE,
  mobileNumber,
  verificationCode
});

export const restartLoginProcess = () => ({
  type: RESTART_LOGIN_PROCESS
});

export const resendVerificationCode = ({ mobileNumber }) => ({
  type: RESEND_VERIFICATION_CODE,
  mobileNumber
});

export const submitBetSlipNumber = ({ betSlipNumber }) => ({
  type: SUBMIT_BET_SLIP_NUMBER,
  betSlipNumber
});

export const logOut = () => ({
  type: LOGOUT
});

export const logoutConfirm = () => ({
  type: LOGOUT_CONFIRM
});

export const logoutReject = () => ({
  type: LOGOUT_REJECT
});
